import { useEffect, useState } from "react";

export function CountdownTimer({ unix_time }) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    // Calculate initial time left
    const calculateTimeLeft = () => {
      const difference = unix_time * 1000 - Date.now();

      if (difference <= 0) {
        // Timer expired
        setTimeLeft("00:00");
        return false;
      }

      // Convert to minutes and seconds
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      // Format as MM:SS
      setTimeLeft(`${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`);

      return true;
    };

    // Initial calculation
    const shouldContinue = calculateTimeLeft();

    if (!shouldContinue) {
      return;
    }

    // Update every second
    const timerId = setInterval(() => {
      const shouldContinue = calculateTimeLeft();
      if (!shouldContinue) {
        clearInterval(timerId);
      }
    }, 1000);

    // Clean up on unmount
    return () => clearInterval(timerId);
  }, [unix_time]);

  return (
    <span>
      <b>{timeLeft}</b>
    </span>
  );
}

export function CountdownTimerWithReset({ unix_time, cancelOtp }) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    // Calculate initial time left
    const calculateTimeLeft = () => {
      const difference = unix_time * 1000 - Date.now();

      if (difference <= 0) {
        // Timer expired
        setTimeLeft("00:00");
        return false;
      }

      // Convert to minutes and seconds
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      // Format as MM:SS
      setTimeLeft(`${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`);

      return true;
    };

    // Initial calculation
    const shouldContinue = calculateTimeLeft();

    if (!shouldContinue) {
      return;
    }

    // Update every second
    const timerId = setInterval(() => {
      const shouldContinue = calculateTimeLeft();
      if (!shouldContinue) {
        clearInterval(timerId);
      }
    }, 1000);

    // Clean up on unmount
    return () => clearInterval(timerId);
  }, [unix_time]);

  return (
    <div className="mb-3 d-flex align-items-center" style={{ gap: "16px" }}>
      {timeLeft === "00:00" ? (
        <span className="d-flex align-items-center text-danger">
          OTP sudah tidak berlaku.{" "}
          <button
            className="btn btn-sm btn-outline-primary ml-2"
            type="button"
            onClick={() => cancelOtp()}
          >
            Kembali ke login
          </button>
        </span>
      ) : (
        <div className="d-flex align-items-center">
          <span>
            Waktu tersisa: <b>{timeLeft}</b>
          </span>
          <button
            className="btn btn-danger btn-sm text-sm ml-3"
            type="button"
            onClick={() => cancelOtp()}
          >
            <i className="fa fa-times mr-1"></i> Batalkan OTP
          </button>
        </div>
      )}
    </div>
  );
}
